import React from "react";
import { motion } from "framer-motion";
import { profile, react, redux, sass } from "assets/index";
import circle from "assets/index";
import AppWrap from "wrapper/AppWrap";
import "./Header.scss";
import { useTranslation } from "react-i18next";

const scaleVariants = {
  whiteInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => {
  const { t } = useTranslation();
  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text">{t("welcome")}</p>
              <h1 className="head-text">Fuze</h1>
            </div>
          </div>
          <div className="tag-cmp app__flex">
            <p className="p-text">Web Developer</p>
            <p className="p-text">Freelancer</p>
          </div>
        </div>
      </motion.div>
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        <img src={profile} alt="profile" />
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 1, ease: "easeInOut" }}
          className="overlay circle"
          alt="profile_circle"
          src={circle}
        />
      </motion.div>
      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whiteInView}
        className="app__header-circles"
      >
        {[react, redux, sass].map((item, i) => (
          <div className="circle-cmp app__flex" key={`circle${i}`}>
            <img src={item} alt="circle" />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, "home");
